<script setup>
import { computed, onMounted } from 'vue';
import {
  useFunctionGetter,
  useMapGetter,
  useStore,
} from 'dashboard/composables/store';
import { isEmptyObject } from 'dashboard/helper/commons';
import ZidCard from './ZidCard.vue';
import ZidEditor from './ZidEditor.vue';

const store = useStore();

const integration = useFunctionGetter(
  'integrations/getIntegration',
  'wgpt_zid'
);
const uiFlags = useMapGetter('integrations/getUIFlags');

onMounted(() => {
  if (isEmptyObject(integration.value)) {
    store.dispatch('integrations/get');
  }
});

const showIntegrationHooks = computed(() => {
  return !uiFlags.value.isFetching && !isEmptyObject(integration.value);
});
</script>

<template>
  <div class="overflow-auto w-full my-auto flex flex-wrap h-full">
    <div v-if="showIntegrationHooks" class="w-full">
      <ZidEditor v-if="integration.enabled" :integration="integration" />
      <ZidCard v-else :integration="integration" />
    </div>
  </div>
</template>
